//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EasyTag from "../EasyTag";
import { page as pageOptions } from '@/utils/constants';
var RenderJsx = {
  props: ['render', 'row', 'value', 'index'],
  render: function render() {
    return this.render(this.value, this.row, this.index);
  }
};
var getNextId = function () {
  var id = 0;
  return function () {
    return ++id;
  };
}();
export default {
  name: "TableContent",
  components: {
    RenderJsx: RenderJsx,
    EasyTag: EasyTag
  },
  emits: ['pagination', 'update:page', 'update:limit'],
  props: {
    columns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    total: {
      type: Number,
      default: 0
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 10
    },
    formatter: {
      type: Function
    },
    minHeight: {
      type: [String, Number],
      default: '200px'
    },
    tableStyle: {
      type: [String, Object],
      default: ''
    }
  },
  data: function data() {
    return {
      tableKey: 'table-content-' + getNextId(),
      pageOptions: pageOptions,
      sortMap: {}
    };
  },
  computed: {
    pageNum: {
      get: function get() {
        return this.page;
      },
      set: function set(val) {
        this.$emit('update:page', val);
        return val;
      }
    },
    pageSize: {
      get: function get() {
        return this.limit;
      },
      set: function set(val) {
        this.$emit('update:limit', val);
        return val;
      }
    },
    compStyles: function compStyles() {
      var minHeight = this.minHeight;
      if (/^(\d)*(\.(\d)*)?$/.test(minHeight)) {
        minHeight = Number(minHeight) + 'px';
      }
      return {
        '--min-height': minHeight
      };
    }
  },
  watch: {
    columns: {
      handler: function handler() {
        this.initSortMaps();
      },
      deep: true,
      immediate: true
    }
  },
  mounted: function mounted() {
    for (var key in this.$refs.tableRef) {
      if (typeof this.$refs.tableRef[key] === 'function' && typeof this[key] === 'undefined') {
        this[key] = this.$refs.tableRef[key];
      }
    }
  },
  methods: {
    reset: function reset() {
      var _this = this;
      var sortMapKeys = Object.keys(this.sortMap);
      sortMapKeys.forEach(function (key) {
        _this.sortMap[key] = '';
      });
    },
    pagination: function pagination() {
      var sortMap = {};
      for (var key in this.sortMap) {
        if (this.sortMap[key]) sortMap[key] = this.sortMap[key];
      }
      this.$emit('pagination', {
        sortMap: sortMap
      });
    },
    pageNumChange: function pageNumChange(page) {
      this.pageNum = page;
      this.pagination();
    },
    pageSizeChange: function pageSizeChange(val) {
      this.pageSize = val;
      this.pagination();
    },
    initSortMaps: function initSortMaps() {
      var _this2 = this;
      var remoteSortList = [];
      this.columns.forEach(function (item) {
        if (item.sortKey) remoteSortList.push(item.sortKey);
      });
      var sortMapKeys = Object.keys(this.sortMap);
      sortMapKeys.forEach(function (key) {
        if (!remoteSortList.includes(key)) {
          delete _this2.sortMap[key];
        }
      });
      remoteSortList.forEach(function (key) {
        if (typeof _this2.sortMap[key] === 'undefined') {
          _this2.$set(_this2.sortMap, key, '');
        }
      });
    },
    initSelection: function initSelection() {
      var _this3 = this;
      var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
        return false;
      };
      this.$refs.tableRef.clearSelection();
      var selectRows = this.list.filter(filter);
      if (selectRows) {
        selectRows.forEach(function (row) {
          _this3.$refs.tableRef.toggleRowSelection(row, true);
        });
      }
    },
    formatCell: function formatCell(type, column, scope) {
      if (this.formatter && typeof this.formatter === 'function') {
        return this.formatter(column.key, scope.row[column.key], type, scope);
      }
      var _ref = column.formatOptions || {},
        _ref$list = _ref.list,
        list = _ref$list === void 0 ? [] : _ref$list,
        _ref$label = _ref.label,
        label = _ref$label === void 0 ? 'label' : _ref$label,
        _ref$value = _ref.value,
        value = _ref$value === void 0 ? 'value' : _ref$value,
        _ref$tag = _ref.tag,
        tag = _ref$tag === void 0 ? 'tag' : _ref$tag;
      var defaultValue = type === 'text' ? '-' : '';
      var valueKey = type === 'text' ? label : tag;
      var target = list.find(function (item) {
        return item[value] === scope.row[column.key];
      });
      return target && target[valueKey] || defaultValue;
    },
    handleSortClick: function handleSortClick(key) {
      for (var k in this.sortMap) {
        if (k === key) {
          var nowVal = this.sortMap[k];
          var nextVal = '';
          if (!nowVal) nextVal = 'descending';
          if (nowVal === 'descending') nextVal = 'ascending';
          this.sortMap[k] = nextVal;
        } else {
          this.sortMap[k] = '';
        }
      }
      this.pageNumChange(1);
    }
  }
};